<template lang="pug">
.card
  .card-header
    h3.card-title フォーム
  .card-body
    section.youtube_url
      div.form-group
        textarea#youtube_debug_json.form-control(type='text',
        name='json', placeholder='デバッグ情報をペースト',
        @paste='parseJson')
      div.form-group(v-if="addocid!=''")
        h3 URL
        input.form-control.form-control-lg(type="text",:value="youtube_url")
      div.form-group(v-if="addocid!=''")
        h3 Preview
        iframe(width='900', height='506', :src="youtube_embed_url", style="border:none")
      div.form-group(v-if="addocid!=''")
        h3 タグ
        vue-tags-input(v-model="tag", :tags="$store.state.tag.items", :autocomplete-items="filteredItems", @tags-changed="tagChange", @input="tagAutoComplete")
  div.card-footer(v-if="addocid!=''")
    button.btn.btn-primary(type='submit', @click='submit')
      span 登録する
</template>

<script>
import Vue from 'vue'
import VueTagsInput from '@johmun/vue-tags-input';

import TagInputMixin from '../../mixins/tag-input'

export default {
  props: {
    after_submit_path: {type: String, default: ""},
    youtube: {type: Object, default: ""},
  },
  components: {
    VueTagsInput,
  },
  methods: {
    parseJson(e){
      //e.preventDefault()
      setTimeout(() => {
        try{
          const obj = JSON.parse(e.target.value);
          //this.addocid = obj.addocid
          this.$store.commit("youtube/setToken", obj.addocid)
        } catch(e){
          console.log(e)
          this.$toasted.error('入力形式が正しくありません。')
          this.$store.commit("youtube/setToken", "")
        }
      })
    },
    async submit(e){
      const r = await this.$store.dispatch("youtube/create", this.$store.state.tag.items)
      if(r.status == 201){
        location.href = this.after_submit_path
      }
    },
  },
  //setAutocompleteItems
  async mounted(){
    await Vue.nextTick()
    if(this.youtube != ""){
      this.$store.commit("youtube/setToken", this.youtube.token)
      const tags = this.youtube.tags.map(tag => {
        return {text: tag.name}
      })
      this.$store.commit("tag/setItems", tags)
    }
  },
  watch: {
  },
  mixins: [TagInputMixin],
  computed: {
    youtube_url(){
      return "https://www.youtube.com/watch?v=" + this.addocid
    },
    youtube_embed_url(){
      return "https://www.youtube.com/embed/" + this.addocid + "?loop=1&autoplay=0&mute=0&rel=0&modestbranding=1"
    },
    addocid() {
      return this.$store.state.youtube.token
    }
  }
}
</script>
<style lang="scss" scoped>
h3{
  font-size: 1.1rem;
  font-weight: 900;
}
</style>
